import { useSphere } from "@react-three/cannon";
import { useFrame } from "@react-three/fiber";
import { cursor } from "../utils";

export default () => {
  const [ref, api] = useSphere(() => ({ mass: 0, args: [0], position: [0, 0, 10000], type: 'Kinematic' }), cursor);
  useFrame(({ mouse, viewport: { height, width } }) => {
    const x = mouse.x * width;
    const y = (mouse.y * height) / 1.9 + -x / 3.5;
    api.position.set(x / 1.4, y, 0);
  });

  return (
    <mesh ref={ref}>
      {/* <sphereGeometry args={[0.5, 32, 32]} /> */}
      {/* <meshBasicMaterial fog={false} depthTest={false} transparent opacity={0.5} /> */}
    </mesh>
  );
};
